module.exports = __webpack_public_path__ + "assets/back-dialog.d7380128.svg";